import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";

import { connect } from "react-redux";
import { patchImageSlider } from 'redux/image-sliders/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import './ImageSliderName.css';

const ENTER_KEY = 13;


class ImageSliderName extends Component {
  static propTypes = {
    patchImageSlider: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    location: PropTypes.object,
    itemId: PropTypes.number.isRequired,
    patchImageSliderError: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    patchImageSliderError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.name) {
      this.setState({
        initialValue: this.props.name,
        currentValue: this.props.name,
      });
    }

    if (this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.name !== this.props.name) {
      this.setState({ currentValue: this.props.name });
    }

    if (prevProps.location !== this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeValue = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('name', currentValue);
      this.props.patchImageSlider(this.props.itemId, form);
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeValue();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeValue();
  };

  executeValidation = () => {
    const { patchImageSliderError } = this.props;
    const { currentValue } = this.state;

    if (patchImageSliderError && patchImageSliderError.name) {
      return patchImageSliderError.name;
    }
    if (currentValue === '' ) {
      return i18n.t("Image Slider name should not be empty");
    }
    return null;
  };

  render() {
    const { currentValue } = this.state;

    return (
      <div className="image-slider-name__component">
        <div className="input-wrapper">
          <InputField
            value={currentValue}
            onChange={(e) => {
              e.preventDefault();
              this.setState({ currentValue: e.target.value });
            }}
            customRef={this.inputEditFieldRef}
            error={this.executeValidation() && {text: this.executeValidation()}}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    patchImageSliderError: state.imageSlidersReducer.patchImageSliderError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchImageSlider,
  },
)(onClickOutside(ImageSliderName));
